import { Form } from 'formik';
import { MaskedInput, TextInput } from './../../../../Inputs';
import { useSettingsStyles } from '../styles';
import { useL10n } from '@uplift/hooks';
import { EmergencyContactFormType } from './EmergencyContactSettingsRow.hooks';

export type EmergencyContactFormProps = {
  labels?: Partial<EmergencyContactFormType>;
};

export const EmergencyContactForm: React.VFC<EmergencyContactFormProps> = (props) => {
  const l10n = useL10n();
  const { classes } = useSettingsStyles();

  return (
    <Form className={classes.formGroup}>
      <TextInput
        autoFocus
        label={props.labels?.name ?? l10n.accountSettings.profile.fullName}
        name="name"
        fullWidth
      />
      <TextInput
        label={props.labels?.relationship ?? l10n.accountSettings.profile.relationshipToYou}
        name="relationship"
        fullWidth
      />
      <MaskedInput
        label={props.labels?.phone ?? l10n.accountSettings.profile.mobilePhone}
        name="phone"
        fullWidth
        type="phone"
        inputProps={{ inputMode: 'tel' }}
      />
    </Form>
  );
};
